import React from 'react';
import "./CardSelectCompany.scss";
import {saveItemInStorage} from "../../../helper/storage";
import {useHistory} from "react-router-dom";

const CardSelectCompany = ({id, name, logo}) => {
  const history = useHistory();

  const handleCompanySelection = () => {
    saveItemInStorage("COMPANY_ID", id, true);
    history.push("/");
  }

  return (
    <div
      className={`card-selectcompany ${!logo ? "no-logo" : ""}`}
      style={logo ? { backgroundImage: `url(${logo})` } : undefined}
      onClick={handleCompanySelection}
    >
      {!logo && (
        <div className="card-logo-placeholder">
          <span>{name?.charAt(0) || "?"}</span>
        </div>
      )}
      <p>{name}</p>
    </div>
  );
};

export default CardSelectCompany;
